module.exports = __webpack_public_path__ + "img/3.e6c94dab.jpg";